<template>
    <div class="payment-status" v-cloak>
      <!--失败时： 用icon-iconfontguanbi fail替换icon-duihao2 bg-color-red-->
      <div
        class="iconfont icon-duihao2 bg-color-red"
        v-if="orderInfo.paid == 1"
      ></div>
      <div class="iconfont icon-iconfontguanbi fail" v-else></div>
      <!-- 失败时：订单支付失败 -->
      
      <div class="status" v-if="orderInfo.paid == 1">订单支付成功</div>
      <div class="status" v-else>订单支付失败</div>
      <div class="wrapper">
        <div class="item acea-row row-between-wrapper">
          <div>订单编号</div>
          <div class="itemCom" v-text="orderInfo.order_id"></div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>支付金额</div>
          <div class="itemCom" v-text="orderInfo.pay_price"></div>
        </div>
        <!--失败时加上这个  -->
        
      </div>
      <!--失败时： 重新购买 -->
      
      
      <div class="returnBnt cart-color" @click="goPages('/')">返回首页</div>
      
    </div>
  </template>
  <script>
  import { mapGetters } from "vuex";
  import { getStatusRenewal } from "@api/order";
  import { isWeixin } from "@utils";
  
  const NAME = "AgencyRenewalStatus";
  
  export default {
    name: NAME,
    props: {},
    data: function() {
      return {
        id: "",
        status: 0,
        msgContent: "",
        orderInfo: {},
        isWeixin: isWeixin()
      };
    },
    watch: {
      $route(n) {
        if (n.query.msg) this.msgContent = n.query.msg;
        if (n.name === NAME && this.id !== n.params.id) {
          this.id = n.params.id;
          this.status = parseInt(n.params.status);
          this.getOrderInfo();
        }
      }
    },
    computed: {
      ...mapGetters(["userInfo"])
    },
    mounted() {
      this.id = this.$route.params.id;
      // this.msgContent = this.$route.query.msg;
      // this.status = parseInt(this.$route.params.status);
      this.getOrderInfo();
    },
    methods: {
      goPages(route) {
        let routes =
          route !== undefined
            ? route
            : "/order/detail/" + this.orderInfo.order_id;
        if (this.status === 5 && route === undefined) routes = "/order/list/0";
        return this.$router.push({
          path: routes
        });
      },
      getOrderInfo() {
        getStatusRenewal(this.id).then(res => {
          this.orderInfo = res.data.result;
          if (this.orderInfo.paid == 1) {
            document.title = "支付成功";
          } else {
            document.title = "支付失败";
          }
        });
      }
    }
  };
  </script>
  